import { Link } from "react-router-dom";
import { Mail, Facebook } from "lucide-react";

const FACEBOOK_URL = "https://www.facebook.com/reel/232805032778074";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--forest)] text-[var(--bone)] relative overflow-hidden">
      <div className="container-x py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4 mb-6">
            <img src="/logo.png" alt="Irene Foundation" className="w-14 h-14 object-contain" />
            <div className="overline text-[var(--terracotta)]">Irene Foundation</div>
          </div>
          <h3 className="font-serif text-4xl md:text-5xl mt-4 leading-none tracking-tight">
            Build a school.<br/>Build a future.
          </h3>
          <p className="mt-6 text-[var(--bone)]/70 max-w-md leading-relaxed">
            A non-profit <strong className="text-[var(--bone)]">registered in Nigeria</strong>, turning unconducive
            classroom environments into modern, safe spaces for teaching — and expanding STEM access across
            Africa, especially for girls.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[var(--bone)]/60 mb-5">Visit</div>
          <ul className="space-y-3 text-sm">
            <li><a href="/#mission" className="hover:text-[var(--terracotta)]">Our mission</a></li>
            <li><a href="/#founder" className="hover:text-[var(--terracotta)]">Founder&rsquo;s note</a></li>
            <li><a href="/#programs" className="hover:text-[var(--terracotta)]">Programs</a></li>
            <li><a href="/#goals" className="hover:text-[var(--terracotta)]">Goals</a></li>
            <li><Link to="/donate" className="hover:text-[var(--terracotta)]">Donate</Link></li>
            <li><Link to="/membership" className="hover:text-[var(--terracotta)]">Membership</Link></li>
            <li><Link to="/volunteer" className="hover:text-[var(--terracotta)]">Volunteer</Link></li>
            <li><Link to="/partner" className="hover:text-[var(--terracotta)]">Collaborate</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-[var(--bone)]/60 mb-5">Contact</div>
          <p className="text-sm text-[var(--bone)]/70">
            <a href="mailto:irenefoundation1@gmail.com" data-testid="footer-email" className="hover:text-[var(--terracotta)] break-all">irenefoundation1@gmail.com</a><br/>
            Lagos · Nigeria<br/>
            Programs across Africa
          </p>
          <div className="overline text-[var(--bone)]/60 mt-8 mb-4">Follow</div>
          <div className="flex items-center gap-4">
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="w-10 h-10 grid place-items-center border border-[var(--bone)]/30 hover:border-[var(--terracotta)] hover:text-[var(--terracotta)] transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="mailto:irenefoundation1@gmail.com" aria-label="Email" className="w-10 h-10 grid place-items-center border border-[var(--bone)]/30 hover:border-[var(--terracotta)] hover:text-[var(--terracotta)] transition-colors">
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="container-x divider-thin on-dark"></div>
      <div className="container-x py-6 flex flex-col md:flex-row justify-between text-xs text-[var(--bone)]/50">
        <div>© {new Date().getFullYear()} Irene Foundation · Founded 2019 · Registered in Nigeria · Africa</div>
        <div className="font-mono">Rebuild · Educate · Repeat</div>
      </div>
    </footer>
  );
}
